import { BRAND_REACTIONS } from '../../constants/brandReactions';

/** Canonical reaction set offered in the picker, mapped to Stream reaction types. */
export interface ReactionDef {
  type: string;
  emoji: string;
}

/**
 * CORE-1685 — the picker set is the brand kit (`constants/brandReactions`);
 * `emoji` here is only the textual stand-in, the UI draws the kit's images.
 */
export const REACTIONS: ReactionDef[] = BRAND_REACTIONS.map((r) => ({ type: r.type, emoji: r.emoji }));

/** type → emoji, including aliases the backend/web may emit. */
export const REACTION_EMOJI: Record<string, string> = {
  love: '❤️', heart: '❤️', like: '👍', haha: '😂', joy: '😂',
  wow: '😮', sad: '😢', angry: '😡', pray: '🙏', fire: '🔥',
  seedling: '🌱', sparkles: '✨',
  ...Object.fromEntries(BRAND_REACTIONS.map((r) => [r.type, r.emoji])),
};
